export default __webpack_public_path__ + "static/infra_3-043da07794baf62d3edd430657efd8ab.jpeg";